import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import verifyContestReducer from '../Reducers/verifyContest.reducer';
import registerParticipantReducer from '../Reducers/registerParticipant.reducer';
import popupReducer from '../Reducers/popupreducer';

const reducers = combineReducers({
    verifyContestData: verifyContestReducer,
    participant: registerParticipantReducer,
    popupHandler: popupReducer
});

const initialState = {};
const middleware = [thunk];
const store = createStore(reducers, initialState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;